// ============================================================================
// SPANISH TRANSLATIONS - CHAPTER 7: CARTAS Y APOCALIPSIS
// ============================================================================
// Niveles 79-91 (13 niveles, 39 preguntas)

export const chapter7Translations = {
  name: "Cartas y Apocalipsis",
  description: "El que venza heredará todas estas cosas... La sabiduría de arriba santifica la inteligencia",
  
  spiritualWisdom: {
    principle: "La sabiduría de arriba santifica la inteligencia y vivifica el espíritu",
    scripture: "Si alguno de vosotros tiene falta de sabiduría, pídala a Dios (Santiago 1:5)",
    application: "Cada carta apostólica y cada visión del Apocalipsis enriquece nuestra comprensión y fortalece nuestra esperanza"
  },
  
  levels: {
    79: {
      name: "Arresto en Jerusalén",
      challenge: "Estoy dispuesto no sólo a ser atado, sino también a morir en Jerusalén...",
      easy: {
        question: "¿Dónde fue arrestado Pablo en su última visita?",
        options: ["Antioquía", "Éfeso", "Jerusalén", "Corinto"],
        correctAnswer: 2,
        hint: "La ciudad santa que a menudo perseguía a los profetas",
        funFact: "🏛️ ¡Jerusalén: lugar de gloria y sufrimiento para todos los siervos de Dios!"
      },
      medium: {
        question: "¿De qué acusaron los judíos a Pablo?",
        options: [
          "Robo en el Templo",
          "Profanación del Templo al introducir gentiles",
          "Blasfemia contra Moisés",
          "Rebelión contra Roma"
        ],
        correctAnswer: 1,
        hint: "Acusación relacionada con la universalidad del Evangelio",
        funFact: "⛪ ¡Ironía: Pablo acusado de profanar el Templo que honraba profundamente!"
      },
      hard: {
        question: "¿Cómo transformó Pablo su cautiverio en oportunidad?",
        options: [
          "Escapó",
          "Testificó ante las autoridades y escribió sus epístolas",
          "Guardó silencio",
          "Negoció su liberación"
        ],
        correctAnswer: 1,
        hint: "Se trata de transformar la prueba en testimonio",
        funFact: "⛓️ ¡Cadenas físicas, libertad espiritual - poderoso testimonio de fe!"
      }
    },
    
    80: {
      name: "Ante el Gobernador Félix",
      challenge: "Pero mientras disertaba sobre la justicia, el dominio propio y el juicio venidero...",
      easy: {
        question: "¿Ante qué gobernador testificó Pablo de su fe?",
        options: ["Pilato", "Félix", "Festo", "Galión"],
        correctAnswer: 1,
        hint: "Gobernador conocido por su codicia",
        funFact: "⚖️ ¡Félix esperaba un soborno - corrupción frente a integridad!"
      },
      medium: {
        question: "¿Cuál fue la reacción de Félix al mensaje de Pablo?",
        options: [
          "Se convirtió",
          "Se espantó de miedo",
          "Se burló",
          "Permaneció indiferente"
        ],
        correctAnswer: 1,
        hint: "La conciencia turbada por la verdad",
        funFact: "😰 ¡Incluso los corruptos tiemblan ante la verdad divina - conciencia universal!"
      },
      hard: {
        question: "¿Por qué mantuvo Félix a Pablo prisionero dos años?",
        options: [
          "Para protegerlo",
          "Por interés político y esperanza de corrupción",
          "Por olvido",
          "Por convicción"
        ],
        correctAnswer: 1,
        hint: "Se trata de cálculos políticos y personales",
        funFact: "🏛️ ¡Justicia humana corrupta vs justicia divina perfecta - contraste impactante!"
      }
    },

    81: {
      name: "Apelación a César",
      challenge: "¡A César apelo!",
      easy: {
        question: "¿Qué derecho invocó Pablo para evitar un juicio en Jerusalén?",
        options: [
          "Derecho de asilo",
          "Apelación a César (ciudadano romano)",
          "Derecho de fuga",
          "Protección diplomática"
        ],
        correctAnswer: 1,
        hint: "Privilegio de su ciudadanía romana",
        funFact: "🏛️ ¡Ciudadanía romana: pasaporte divino para llevar el Evangelio a Roma!"
      },
      medium: {
        question: "¿Ante quién testificó Pablo antes de partir?",
        options: [
          "El sanedrín",
          "El rey Agripa y Berenice",
          "Los soldados romanos",
          "La multitud judía"
        ],
        correctAnswer: 1,
        hint: "Realeza herodiana judaizada",
        funFact: "👑 ¡Del pastor de rebaños al palacio real - elevación divina de Pablo!"
      },
      hard: {
        question: "¿Cómo usa Dios los sistemas humanos para sus planes?",
        options: [
          "Los ignora",
          "Los utiliza providencialmente para cumplir sus propósitos",
          "Los destruye",
          "Siempre se opone a ellos"
        ],
        correctAnswer: 1,
        hint: "Se trata de la soberanía divina sobre la historia",
        funFact: "🌐 ¡La justicia romana se convierte en vehículo del Evangelio - providencia notable!"
      }
    },

    82: {
      name: "Naufragio en Malta",
      challenge: "No temas, Pablo; es necesario que comparezcas ante César...",
      easy: {
        question: "¿En qué isla naufragó Pablo?",
        options: ["Creta", "Chipre", "Malta", "Sicilia"],
        correctAnswer: 2,
        hint: "Pequeña isla al sur de Sicilia",
        funFact: "🏝️ ¡Malta: parada forzosa que se convierte en misión fructífera - desvíos divinos!"
      },
      medium: {
        question: "¿Qué milagro realizó Pablo en Malta?",
        options: [
          "Calmó la tempestad",
          "Sanó al padre de Publio y otros enfermos",
          "Multiplicó la comida",
          "Resucitó a un muerto"
        ],
        correctAnswer: 1,
        hint: "Sanaciones múltiples en la isla",
        funFact: "🏥 ¡Pablo: de náufrago a médico milagroso - reputación divina!"
      },
      hard: {
        question: "¿Cómo ilustra este naufragio la fidelidad divina?",
        options: [
          "Los accidentes ocurren",
          "Dios protege y cumple sus promesas a pesar de los obstáculos",
          "Pablo tuvo suerte",
          "Era evitable"
        ],
        correctAnswer: 1,
        hint: "Se trata de la fidelidad divina a las promesas",
        funFact: "⛈️ ¡Tormenta, naufragio, serpiente: nada detiene el plan divino para Pablo!"
      }
    },

    83: {
      name: "Pablo en Roma",
      challenge: "Permaneció dos años enteros en una casa alquilada...",
      easy: {
        question: "¿En qué condiciones vivió Pablo en Roma?",
        options: [
          "En prisión cerrada",
          "Bajo arresto domiciliario",
          "En libertad total",
          "En exilio"
        ],
        correctAnswer: 1,
        hint: "Libertad relativa bajo vigilancia",
        funFact: "🏠 ¡Casa-prisión convertida en centro misionero - libertad en cadenas!"
      },
      medium: {
        question: "¿Qué hizo Pablo durante sus dos años en Roma?",
        options: [
          "Descansó",
          "Enseñó y escribió sus epístolas",
          "Preparó su defensa",
          "Hizo turismo"
        ],
        correctAnswer: 1,
        hint: "Ministerio intenso a pesar de las cadenas",
        funFact: "✍️ ¡Epístolas de la cautividad: Efesios, Filipenses, Colosenses, Filemón!"
      },
      hard: {
        question: "¿Cómo terminó Pablo su ministerio según la tradición?",
        options: [
          "Murió de enfermedad",
          "Fue decapitado bajo Nerón alrededor del 67 d.C.",
          "Murió de vejez",
          "Desapareció misteriosamente"
        ],
        correctAnswer: 1,
        hint: "Martirio bajo el emperador loco",
        funFact: "⚔️ '¡He peleado la buena batalla, he acabado la carrera' - victoria final!"
      }
    },

    84: {
      name: "La Epístola a los Romanos",
      challenge: "No me avergüenzo del evangelio, porque es poder de Dios para salvación...",
      easy: {
        question: "¿Qué epístola desarrolla más la doctrina de la salvación por la fe?",
        options: ["1 Corintios", "Gálatas", "Romanos", "Efesios"],
        correctAnswer: 2,
        hint: "La 'catedral' teológica de Pablo",
        funFact: "🏛️ ¡Romanos: obra maestra teológica que convirtió a Agustín y Lutero!"
      },
      medium: {
        question: "Según Romanos, ¿cómo es justificado el hombre ante Dios?",
        options: [
          "Por sus buenas obras",
          "Por la fe sola, sin las obras",
          "Por los sacrificios",
          "Por la tradición"
        ],
        correctAnswer: 1,
        hint: "Principio fundamental de la Reforma",
        funFact: "⚖️ '¡El justo por la fe vivirá' - revolución espiritual de Pablo!"
      },
      hard: {
        question: "¿Cuál es el alcance universal de esta epístola?",
        options: [
          "Concierne solo a los romanos",
          "Expone el plan de salvación para toda la humanidad",
          "Critica solo a Roma",
          "Está obsoleta"
        ],
        correctAnswer: 1,
        hint: "Se trata del plan universal de salvación",
        funFact: "🌍 ¡Evangelio = poder de Dios para todos: judíos y griegos - universalidad total!"
      }
    },

    85: {
      name: "El Himno del Amor - 1 Corintios 13",
      challenge: "Si yo hablase lenguas humanas y angélicas, y no tengo amor...",
      easy: {
        question: "¿Qué capítulo de la Biblia se llama 'el himno del amor'?",
        options: [
          "1 Corintios 12",
          "1 Corintios 13",
          "1 Juan 4",
          "Romanos 8"
        ],
        correctAnswer: 1,
        hint: "El capítulo central de 1 Corintios",
        funFact: "💝 ¡Capítulo más leído en bodas - definición perfecta del amor!"
      },
      medium: {
        question: "¿Qué dice Pablo sobre la duración del amor?",
        options: [
          "El amor pasa con el tiempo",
          "El amor nunca deja de ser",
          "El amor depende de las circunstancias",
          "El amor es temporal"
        ],
        correctAnswer: 1,
        hint: "Eternidad del amor divino",
        funFact: "♾️ ¡Solo el amor atraviesa la muerte y la eternidad - valor supremo!"
      },
      hard: {
        question: "¿Por qué Pablo coloca el amor por encima de los dones espirituales?",
        options: [
          "Los dones son malos",
          "El amor da sentido y valor a todo lo demás",
          "El amor es más fácil",
          "Los dones dividen"
        ],
        correctAnswer: 1,
        hint: "Se trata del motor y sentido de todo servicio",
        funFact: "🎯 ¡Sin amor, incluso los dones más grandes se vuelven ruido y orgullo!"
      }
    },

    86: {
      name: "Efesios: La Iglesia Cuerpo de Cristo",
      challenge: "Sometió todas las cosas bajo sus pies, y lo dio por cabeza sobre todas las cosas a la iglesia...",
      easy: {
        question: "Según Efesios, ¿qué es la Iglesia en su relación con Cristo?",
        options: [
          "Su templo",
          "Su cuerpo",
          "Su familia",
          "Su ejército"
        ],
        correctAnswer: 1,
        hint: "Metáfora orgánica de unidad",
        funFact: "👤 ¡Cuerpo de Cristo: cada cristiano es un miembro vital - interdependencia!"
      },
      medium: {
        question: "¿Qué armadura describe Pablo para el combate espiritual?",
        options: [
          "Armadura física",
          "Armadura de Dios: verdad, justicia, paz, fe, salvación, Palabra",
          "Armadura romana",
          "Protección mágica"
        ],
        correctAnswer: 1,
        hint: "Seis piezas de armadura espiritual",
        funFact: "⚔️ ¡Combate espiritual con armas espirituales - estrategia divina de victoria!"
      },
      hard: {
        question: "¿Contra quién es nuestra verdadera lucha según Pablo?",
        options: [
          "Contra los hombres malvados",
          "Contra las potestades espirituales de maldad",
          "Contra los gobiernos",
          "Contra la pobreza"
        ],
        correctAnswer: 1,
        hint: "Se trata de fuerzas espirituales invisibles",
        funFact: "👹 ¡Combate cósmico: detrás de los conflictos humanos, guerra espiritual real!"
      }
    },

    87: {
      name: "Filipenses: El Gozo en la Prueba",
      challenge: "Regocijaos en el Señor siempre. Otra vez digo: ¡Regocijaos!",
      easy: {
        question: "¿Qué sentimiento anima Pablo a pesar de su prisión?",
        options: ["La resignación", "El gozo", "La ira", "La tristeza"],
        correctAnswer: 1,
        hint: "Emoción sorprendente para un prisionero",
        funFact: "😊 ¡Gozo 16 veces en 4 capítulos - récord de felicidad en prisión!"
      },
      medium: {
        question: "Según Filipenses 2, ¿qué actitud adoptó Jesús?",
        options: [
          "Se impuso por la fuerza",
          "Se despojó y se humilló hasta la muerte",
          "Huyó de sus responsabilidades",
          "Buscó la gloria"
        ],
        correctAnswer: 1,
        hint: "Movimiento descendente voluntario",
        funFact: "📉 ¡Jesús: de la igualdad con Dios a la muerte en cruz - amor extremo!"
      },
      hard: {
        question: "¿Cómo puede Pablo predicar gozo en prisión?",
        options: [
          "Está fingiendo",
          "El gozo cristiano trasciende las circunstancias",
          "Es masoquista",
          "Niega la realidad"
        ],
        correctAnswer: 1,
        hint: "Se trata de un gozo sobrenatural",
        funFact: "✨ ¡Gozo = fruto del Espíritu independiente de las circunstancias - secreto divino!"
      }
    },

    88: {
      name: "Las Epístolas Pastorales",
      challenge: "Pelea la buena batalla de la fe, echa mano de la vida eterna...",
      easy: {
        question: "¿A quiénes escribió Pablo sus últimas cartas pastorales?",
        options: [
          "A los corintios",
          "A Timoteo y Tito",
          "A los romanos",
          "A los gálatas"
        ],
        correctAnswer: 1,
        hint: "Sus hijos espirituales y colaboradores",
        funFact: "👨‍👦 ¡Testamento espiritual: Pablo pasa la antorcha a la siguiente generación!"
      },
      medium: {
        question: "¿Qué consejo da Pablo para elegir líderes de la iglesia?",
        options: [
          "Elegir a los más ricos",
          "Elegir según criterios morales y espirituales estrictos",
          "Elegir a los más instruidos",
          "Elegir a los más populares"
        ],
        correctAnswer: 1,
        hint: "Calificaciones morales ante todo",
        funFact: "⚖️ ¡Estándares altos para líderes: carácter antes que competencia - prioridades divinas!"
      },
      hard: {
        question: "¿Qué herencia deja Pablo a Timoteo?",
        options: [
          "Bienes materiales",
          "La fidelidad al Evangelio y el ministerio pastoral",
          "Una función política",
          "Una escuela teológica"
        ],
        correctAnswer: 1,
        hint: "Se trata de herencia espiritual",
        funFact: "📜 '¡Guarda el buen depósito' - transmisión fiel del Evangelio a través de las edades!"
      }
    },

    89: {
      name: "Hebreos: Jesús Sumo Sacerdote",
      challenge: "Tenemos un gran sumo sacerdote que traspasó los cielos...",
      easy: {
        question: "Según Hebreos, ¿quién es nuestro gran sumo sacerdote?",
        options: ["Aarón", "Moisés", "Jesús", "Melquisedec"],
        correctAnswer: 2,
        hint: "El mediador perfecto entre Dios y los hombres",
        funFact: "✝️ ¡Jesús: Sacerdote y Víctima - sacrificio perfecto una vez para siempre!"
      },
      medium: {
        question: "¿Por qué el sacerdocio de Jesús es superior al de Aarón?",
        options: [
          "Es más antiguo",
          "Es eterno según el orden de Melquisedec",
          "Es más rico",
          "Es más popular"
        ],
        correctAnswer: 1,
        hint: "Eternidad vs temporalidad",
        funFact: "♾️ ¡Sacerdocio eterno: Jesús intercede perpetuamente por nosotros!"
      },
      hard: {
        question: "¿Cómo presenta Hebreos el Nuevo Pacto?",
        options: [
          "Idéntico al antiguo",
          "Superior y definitivo, escrito en los corazones",
          "Temporal",
          "Opcional"
        ],
        correctAnswer: 1,
        hint: "Se trata de cumplimiento y superación",
        funFact: "📋 ¡Nuevo Pacto: ley escrita en los corazones, no en piedra!"
      }
    },

    90: {
      name: "Santiago: La Fe y las Obras",
      challenge: "La fe sin obras está muerta...",
      easy: {
        question: "Según Santiago, ¿qué debe acompañar a la fe?",
        options: [
          "Las palabras",
          "Las obras",
          "Las emociones",
          "El conocimiento"
        ],
        correctAnswer: 1,
        hint: "Manifestación práctica de la fe",
        funFact: "🌳 ¡Fe = raíz, obras = frutos - árbol espiritual completo!"
      },
      medium: {
        question: "¿Con qué compara Santiago la lengua?",
        options: [
          "Con una espada",
          "Con un pequeño fuego que enciende un gran bosque",
          "Con un instrumento musical",
          "Con una herramienta"
        ],
        correctAnswer: 1,
        hint: "Pequeño miembro pero gran poder destructivo",
        funFact: "🔥 ¡Lengua: pequeño miembro pero puede incendiar toda una vida - prudencia!"
      },
      hard: {
        question: "¿Cómo conciliar Santiago y Pablo sobre fe/obras?",
        options: [
          "Se contradicen",
          "Pablo habla de justificación, Santiago de santificación",
          "Uno está equivocado",
          "No hay solución"
        ],
        correctAnswer: 1,
        hint: "Se trata de dos aspectos complementarios",
        funFact: "⚖️ ¡Pablo: salvos por fe / Santiago: fe probada por obras - armonía perfecta!"
      }
    },

    91: {
      name: "Apocalipsis: El Retorno del Rey",
      challenge: "He aquí vengo pronto. ¡Bienaventurado el que guarda las palabras de este libro!",
      easy: {
        question: "¿A cuántas iglesias escribe Juan en Apocalipsis?",
        options: ["5", "7", "10", "12"],
        correctAnswer: 1,
        hint: "El número de la perfección",
        funFact: "⛪ ¡7 iglesias de Asia: espejo de todas las iglesias de todos los tiempos!"
      },
      medium: {
        question: "¿Cómo termina la historia según Apocalipsis?",
        options: [
          "Destrucción total",
          "Cielos nuevos y tierra nueva",
          "Regreso al paraíso terrenal",
          "Fin de toda existencia"
        ],
        correctAnswer: 1,
        hint: "Renovación completa de la creación",
        funFact: "🌅 ¡No fin del mundo sino renovación total - esperanza última!"
      },
      hard: {
        question: "¿Qué mensaje central transmite Apocalipsis a los perseguidos?",
        options: [
          "Resignaos",
          "Cristo reina y triunfará definitivamente",
          "Huid de la persecución",
          "Vengaos"
        ],
        correctAnswer: 1,
        hint: "Se trata de esperanza en la victoria final",
        funFact: "👑 '¡El que era, el que es y el que ha de venir' - Señor de la historia y el tiempo!"
      }
    }
  }
};

export default chapter7Translations;
